<script setup lang="ts">
import { ref } from 'vue'
import {RouterLink, useRoute} from 'vue-router'
import logo from "@/assets/banner.png"

const mobileMenuOpen = ref(false)
const route =  useRoute()

const toggleMobileMenu = () => {
  mobileMenuOpen.value = !mobileMenuOpen.value
}
</script>

<template>
  <header class="bg-white shadow py-4">
    <div class="max-w-300 mx-auto px-4">
      <div class="flex items-center justify-between">
        <!-- Logo -->
        <RouterLink to="/" class="flex items-center cursor-pointer">
          <img :src="logo" alt="URSB Logo" class="h-8 w-auto rounded">
        </RouterLink>


        <!-- Mobile Menu Button -->
        <button
          @click="toggleMobileMenu"
          class="md:hidden text-gray-700 hover:text-[#0077C0] cursor-pointer"
        >
          <i v-if="!mobileMenuOpen" class="fa-solid fa-bars text-2xl"></i>
          <i v-else class="fa-solid fa-times text-2xl"></i>
        </button>
      </div>

      <!-- Mobile Menu -->
      <div v-if="mobileMenuOpen" class="md:hidden mt-4 pb-4 border-t border-gray-200 pt-4">
      </div>
    </div>
  </header>
</template>
